export type OrderPriceType = 'market' | 'limit' | 'trigger';
export type OrderTriggerExecutionType = 'market' | 'limit';

export interface ResolveOrderPriceParams {
  priceType: OrderPriceType;
  /** priceType이 'trigger'일 때만 의미가 있다(Trigger Limit vs Trigger Market). */
  triggerExecutionType: OrderTriggerExecutionType;
  isBbo: boolean;
  limitPrice: string | null | undefined;
  triggerPrice: string | null | undefined;
  /** 값이 없을 때 대체할 기준가(ask/bid/reference). */
  fallbackPrice: string;
}

/**
 * 주문 기준가(order price) 선택 규칙.
 *
 * Limit / Trigger Limit 주문은 limit price(BBO 시 기준가) 기반, Trigger Market 주문은 trigger price 기반,
 * Market 주문은 기준가 그대로. price.ts의 ask/bid/reference 3개 트랙(realtime·throttled)에서 fallbackPrice만
 * 달리해 동일하게 쓰던 switch를 하나로 통합한 것.
 *
 * limit/trigger price는 nullish(`??`)일 때만 fallback으로 대체한다 — 빈 문자열('')은 그대로 반환한다
 * (기존 price.ts 동작과 동일). 계산·검증 정확성이 필요한 경로가 이 값을 소비하므로 `||`로 바꾸지 말 것.
 */
export function resolveOrderPrice({
  priceType,
  triggerExecutionType,
  isBbo,
  limitPrice,
  triggerPrice,
  fallbackPrice,
}: ResolveOrderPriceParams): string {
  switch (priceType) {
    case 'limit':
      if (isBbo) return fallbackPrice;
      return limitPrice ?? fallbackPrice;
    case 'trigger':
      if (triggerExecutionType === 'limit') {
        if (isBbo) return fallbackPrice;
        return limitPrice ?? fallbackPrice;
      }
      return triggerPrice ?? fallbackPrice;
    case 'market':
      return fallbackPrice;
    default:
      return '0';
  }
}
